var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42891 0.277062C6.78722 0.632853 6.78825 1.21207 6.43119 1.56912L3.68335 4.31697C3.2477 4.75261 3.2477 5.45894 3.68335 5.89458L6.43119 8.64243C6.78825 8.99948 6.78722 9.5787 6.42891 9.93449V9.93449C6.07238 10.2885 5.49668 10.2875 5.14141 9.93221L1.10378 5.89458C0.66813 5.45894 0.668131 4.75261 1.10378 4.31697L5.14141 0.279336C5.49668 -0.0759387 6.07238 -0.0769552 6.42891 0.277062V0.277062Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderBack);
export default __webpack_public_path__ + "static/media/calenderBack.77cf5e388dfab0bb21c2a68e7833cc6b.svg";
export { ForwardRef as ReactComponent };